import { ScreeningViewTemplate } from '../ScreeningTemplate'
import { useScreeningDescriptionText } from '../ScreeningShared'
import { useScreeningContinue } from '../useScreeningContinue'
import { ScreeningType } from '@estercare/ester-shared'
import { useTranslation } from 'react-i18next'

export const ScreeningStandardContinue = () => {
  const { t } = useTranslation()
  const screeningDescription = useScreeningDescriptionText(ScreeningType.STANDARD)
  const { onContinue, optInFields, isButtonDisabled, errorMsg } = useScreeningContinue('standard_continue')
  return (
    <ScreeningViewTemplate
      pageTitle={t('employee.screening.standardContinuePage')}
      screeningTitle={t('employee.screening.standardTitle')}
      screeningDescription={screeningDescription}
      screeningAdditionalChildren={optInFields}
      buttonText={t('employee.screening.standardContinueButton')}
      onButtonClick={onContinue}
      isButtonDisabled={isButtonDisabled}
      errorMsg={errorMsg}
    />
  )
}
